import React from 'react';
import PropTypes from 'prop-types';
import { VaDetails } from '@department-of-veterans-affairs/component-library/dist/react-bindings';
import {
  numberUI,
  numberSchema,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import content from '../../utils/content.json';

const Description = () => (
  <div>
    <p>
      A dependent child is an unmarried child (including an adopted child or
      stepchild) who meets 1 of these eligibility requirements:
    </p>
    <ul>
      <li>They’re under 18 years old, or</li>
      <li>
        They’re between the ages of 18 and 23 years old and enrolled in school,
        or
      </li>
      <li>They became permanently disabled before they turned 18</li>
    </ul>
  </div>
);

Description.propTypes = {
  formData: PropTypes.object,
};

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI({
      title: content['household-dependents-count-title'],
      description: ({ formData }) => <Description formData={formData} />,
    }),
    veteranChildrenCount: {
      ...numberUI({
        title: content['household-dependents-surviving-adult-child'],
        updateUiSchema: data => ({
          'ui:title':
            content[
              {
                SURVIVING_CHILD: 'household-dependents-surviving-adult-child',
                SURVIVING_SPOUSE: 'household-dependents-spouse',
                CUSTODIAN_FILING_FOR_CHILD_UNDER_18:
                  'household-dependents-custodian',
              }[data?.claimantRelationship] ||
                'household-dependents-surviving-adult-child'
            ],
        }),
        hint: content['household-dependents-count-number-hint'],
        errorMessages: {
          pattern: content['number-error'],
        },
        min: 0,
        max: 99,
      }),
    },
    dependentUnderYourCare: {
      ...numberUI({
        title: content['dependent-under-your-care'],
        hint: content['household-dependents-count-number-hint'],
        hideIf: formData =>
          formData?.claimantRelationship === 'SURVIVING_CHILD',
      }),
      'ui:required': formData =>
        formData?.claimantRelationship !== 'SURVIVING_CHILD',
    },
    'view:dependentChildInfo': {
      'ui:description': (
        <VaDetails label="Why do you need to know about children not under my care?">
          For the D.I.C. benefit, we consider all children of the Veteran when
          determining possible payment amounts.
        </VaDetails>
      ),
      'ui:options': {
        displayEmptyObjectOnReview: true,
      },
    },
  },
  schema: {
    type: 'object',
    required: ['veteranChildrenCount'],
    properties: {
      veteranChildrenCount: numberSchema,
      dependentUnderYourCare: numberSchema,
      'view:dependentChildInfo': {
        type: 'object',
        properties: {},
      },
    },
  },
};
